<template>
    <tr class="c-table__row">
        <td class="c-table__cell center">
            <input v-model="phoneNumber.selected" id="checkbox1" name="checkboxes" type="checkbox">
        </td>

        <td class="c-table__cell">
            {{ phoneNumber.friendly_name }}
        </td>

        <td class="c-table__cell">
            {{ phoneNumber.iso_country || '-' }}
        </td>

        <td class="c-table__cell hidden-xs">
            {{ phoneNumber.region || '-' }}
        </td>

        <td class="c-table__cell hidden-xs">
            {{ phoneNumber.locality || '-' }}
        </td>

        <td class="c-table__cell hidden-xs">
            {{ phoneNumber.postal_code || '-' }}
        </td>

        <!-- <td class="c-table__cell center hidden-xs">
            <span class="u-block center">$1.50</span>
            <span class="u-block u-text-mute u-text-xsmall">monthly</span>
        </td> -->

        <td class="c-table__cell center">
            <a v-if="!purchased && !buying && !error" @click.prevent="buy" class="c-btn c-btn--success" href="#">Add</a>

            <a v-if="buying" class="c-btn c-btn--success is-disabled" href="#">
                Adding
                <i class="fa fa-spin fa-circle-o-notch"></i>
            </a>

            <a v-if="purchased" class="c-btn c-btn--success is-disabled" href="#">Added</a>

            <p v-if="error" class="u-text-danger">{{ errorMessage }}</p>
        </td>
    </tr>
</template>

<script>
export default {
    props: ['phoneNumber'],

    data(){
        return {
            purchased: false,
            buying: false,
            error: false,
            errorMessage: null
        };
    },

    created(){
        Bus.$on(`phone_numbersBuying-${this.phoneNumber.phone_number}`, () => {
            this.buying = true;
        });

        Bus.$on(`phone_numbersPurchased-${this.phoneNumber.phone_number}`, () => {
            this.purchased = true;
            this.buying = false;
        });

        Bus.$on(`phone_numbersPurchaseError-${this.phoneNumber.phone_number}`, (message) => {
            if (message) {
                this.error = true;
                this.errorMessage = message;
                $('[data-toggle="popover"]').popover({trigger: 'hover'});
            }

            this.buying = false;
        });
    },

    methods: {
        buy() {
            this.buying = true;
            Bus.$emit('phone_numbersBuy', this.phoneNumber.phone_number, this.phoneNumber.vendor, this.phoneNumber.iso_country);
        }
    }
};
</script>
